// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
  const disabledStyle = {
    "&.Mui-disabled": {
      color: theme.palette.primary["400"],
    },
  }

  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: 400,
        },

        contained: {
          backgroundColor: theme.palette.primary["darker"],
          ...disabledStyle,
        },
        outlined: {
          ...disabledStyle,
        },
      },
    },
  }
}
